import React, { useContext } from 'react';
import UniverseContext from './UniverseContext';

// Small per-node symbol binder shown only when the strategy has a multi-asset
// universe. Lets a node read/trade a specific symbol; empty value = "Primary"
// (the symbol the backtest is run against). Kept tiny and consistent so it can
// drop into every data/action node without bespoke styling.
export default function NodeSymbolSelect({ value, onChange }) {
  const universe = useContext(UniverseContext) || [];
  if (!universe.length) return null; // single-symbol strategy: no clutter

  // Index 0 is the primary; an unset value defaults to it.
  const primary = universe[0]?.symbol;
  // Secondary symbols get their own options; the primary is represented by the
  // default "primary" option (empty value) so a node stays bound to the primary
  // role even if the user changes which ticker is primary.
  const secondaries = universe.slice(1);
  // A stored symbol equal to the primary ticker is the primary role (empty).
  const effectiveValue = value && value.toUpperCase() !== String(primary || '').toUpperCase() ? value : '';

  return (
    <select
      value={effectiveValue}
      onChange={(e) => onChange(e.target.value)}
      title="Which symbol this node reads/trades"
      style={{
        width: '100%',
        padding: 4,
        marginBottom: 6,
        background: 'var(--surface)',
        color: 'var(--text)',
        border: '1px dashed var(--border)',
        borderRadius: 4,
        fontSize: 11,
      }}
    >
      <option value="">● {primary} (primary)</option>
      {secondaries.map((u) => (
        <option key={u.symbol} value={u.symbol}>{u.symbol}</option>
      ))}
    </select>
  );
}
